export const subtitles = {
    "1": {
        "startTime": 14.93,
        "endTime": 23.79,
        "transcript": "Tua-i uumek wani inerqullrunka waten makut ak'allaraat, makut-wa pitalgutenka:",
        "translation": "I advised them this, the elders, my peers:"
    },
    "2": {
        "startTime": 23.795,
        "endTime": 32.875,
        "transcript": "Waten, waten makut wani school-arat makut irniaput ayagyuarnek pilallrit makut nutaan piqatalriit",
        "translation": "This way, these school age children our children who are called the young people who are just starting,"
    },
    "3": {
        "startTime": 34.61,
        "endTime": 38.5,
        "transcript": "Canek-wa pisqevkenaki.",
        "translation": "Not to discourage them."
    },
    "4": {
        "startTime": 38.5,
        "endTime": 45.91,
        "transcript": "Usviilkelluki-llu, usviilkelluki-llu piksaunaki, cali acirturluki canek atqenrilkaitnek.",
        "translation": "Don't tell them that they are crazy, also don't call them names, names that aren't theirs."
    },
    "5": {
        "startTime": 45.91,
        "endTime": 56.7,
        "transcript": "Tuaten pikumta wangkuta makuni wangkuta ak'alla'arni wangkutnek inglukiurciqngamta.",
        "translation": "If we do that, us elders will be creating enemies for ourselves."
    },
    "6": {
        "startTime": 56.7,
        "endTime": 66.26,
        "transcript": "Inglukciqaitkut waten makut elder una wani ellaitnek waten akngirqelluki pikumteki.",
        "translation": "They will be against us elders if we repeatedly hurt them."
    },
    "7": {
        "startTime": 66.26,
        "endTime": 74.4,
        "transcript": "Tau͡gaam qanrulluki mat'umek yuuyaramteńek ak'a cakniullemteńek.",
        "translation": "But to tell them our way of life, our struggles in years past."
    },
    "8": {
        "startTime": 74.405,
        "endTime": 80.58,
        "transcript": "Tamana ellaitnun ikayuutekesqumayaaqluku.",
        "translation": "Hoping these things will be helpful to them."
    },
    "9": {
        "startTime": 80.58,
        "endTime": 90.23,
        "transcript": "Tua-i-wa watua maa-i eglertellemteńi au͡gken wii murilkellemnek maa-i cimirtuq.",
        "translation": "Because while we are still alive as I have been watching, things have changed."
    },
    "10": {
        "startTime": 90.23,
        "endTime": 92.4,
        "transcript": "Ca tamarmi-wa cimirtuq.",
        "translation": "Everything is changing."
    },
    "11": {
        "startTime": 92.4,
        "endTime": 98.03,
        "transcript": "Avanicetun ayuqenrirtuq. Makut-llu yuut cimirluteng.",
        "translation": "It's not the the same as before. Even these people are changing."
    },
    "12": {
        "startTime": 98.37,
        "endTime": 104.46,
        "transcript": "Cali makut irniaput cimirluteng.",
        "translation": "Even our children are changing."
    },
    "13": {
        "startTime": 104.558,
        "endTime": 110.822,
        "transcript": "Cali waten school-aryaurrluteng.",
        "translation": "They now go to school."
    },
    "14": {
        "startTime": 110.822,
        "endTime": 122.563,
        "transcript": "Cangluteng-wa maavet, makunun-llu high school, college tamakunun piyau[rrluteng]. Tamatum nalliini tamakunek tangssuitellruukut.",
        "translation": "They now go to highschool and to college. Back then we never saw these things."
    },
    "15": {
        "startTime": 122.574,
        "endTime": 126.052,
        "transcript": "Waten-llu piyuunateng.",
        "translation": "These never happened."
    },
    "16": {
        "startTime": 126.21,
        "endTime": 134.865,
        "transcript": "Tua-i man'a Kass'at tua-i inglulissiyaagluki pinarqenricaaqaput waten pingraitkut.",
        "translation": "We should not oppose the Kass'aq people so much even though they are doing these to us."
    },
    "17": {
        "startTime": 134.867,
        "endTime": 139.656,
        "transcript": "Tua-i ikayungnaqluta irniamteggun piyaaqait.",
        "translation": "They are trying to help us through our children."
    },
    "18": {
        "startTime": 139.668,
        "endTime": 148.491,
        "transcript": "Tau͡gaam amllerni wangkuta taringnerrluggluku ingluliurutnguluku pilararput.",
        "translation": "But sometimes we do not understand and view it as oppression."
    },
    "19": {
        "startTime": 148.509,
        "endTime": 152.52,
        "transcript": "Irniaput makut navgurniluki makunun aipaimteńun.",
        "translation": "We say that they are “breaking” our children,  these other people."
    },
    "20": {
        "startTime": 152.555,
        "endTime": 161.878,
        "transcript": "Tua-i elitarkaugut. Maa-i elitellermegteggun makut irniamta ayagyuaraat",
        "translation": "They need to learn. Through the education they have received, our children, our young people"
    },
    "21": {
        "startTime": 161.9,
        "endTime": 168.944,
        "transcript": "Wangkuta maa-i ikayungaitkut wangkuta maani ak'allarni. Wangkuta pisciigatukut.",
        "translation": "Are helping us elders of today. We cannot do these things."
    },
    "22": {
        "startTime": 168.95,
        "endTime": 180.661,
        "transcript": "Waniwa-llam una wani Elders' Conference, ukut wani yun'erraraat tua-i ellaita akikangutengnaqluta tuaten man'a eglertellerput",
        "translation": "Even here with this Elders Conference, these young people obtained money for our travel"
    },
    "23": {
        "startTime": 180.677,
        "endTime": 186.51,
        "transcript": "Wangkuta tangrrucelluta tangrrucugnaitqapigtellriani.",
        "translation": "They let us see each other, we who have no other way to get together"
    },
    "24": {
        "startTime": 186.512,
        "endTime": 192.912,
        "transcript": "Tua-i makut wani irniaput tuatelluki.",
        "translation": "Our children are able to do this."
    },
    "25": {
        "startTime": 192.931,
        "endTime": 199.587,
        "transcript": "Wii tua-i irnianka wii-llu tua-i pituyaaqut. Qanerciryanricaaqut.",
        "translation": "My own children don't always follow advice."
    },
    "26": {
        "startTime": 199.612,
        "endTime": 204.09,
        "transcript": "Waniwa tauna elluarr[luku]...",
        "translation": "Waniwa tauna elluarr[luku]..."
    }
};